module.exports = __webpack_public_path__ + "img/landscape-square.88dabf40.png";